import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//import { ReportOutput } from './components/output';
import { Button } from '@mui/material';

export default function ReportPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const reportText = state?.reportText || '';

  if (!reportText) {
    // si se entra directo sin state, volvemos al form
    navigate('/');
    return null;
  }

  return (
    <>
      <Button onClick={() => navigate(-1)}>← Back to Form</Button>
  
    </>
  );
}